import {get } from '@/utils/request';

export var Navbar = params => { return get(`/web/home/rootList`, params).then(res => res) }
export var announce = params => { return get(`/web/home/queryNoticeBatchList`, params).then(res => res) }
export var information = params => { return get(`/web/home/queryBatchList`, params).then(res => res) }
export var queryHomeData = params => { return get(`/web/home/queryHomeData`, params).then(res => res) }
export var queryWorkNewsData = params => { return get(`/web/home/queryWorkNewsData`, params).then(res => res) }

export var queryOrgDetails = params => { return get(`/web/member/queryOrgDetails`, params).then(res => res) }
export var queryById = params => { return get(`/web/member/queryById`, params).then(res => res) }
export var list = params => { return get(`/web/member/list`, params).then(res => res) }


export var lists = params => { return get(`/web/information/list`, params).then(res => res) }

export var Pagingquery = params => { return get(`/web/information/queryById`, params).then(res => res) }
